import { MetadataEntityData } from '../../../metadata/entity/decorators/model/metadata.entity.data';
import { Entity } from '../../entity';
import { EntityFormDefinition } from '../forms/entity.form.definition';
import { EntityFormId } from '../forms/entity.form.id';

export const EntityViewNames = {
    [EntityFormId.Create]: 'Create',
    [EntityFormId.QuickCreate]: 'Quick Create',
}

export interface EntityDefinition extends Entity {
    name: string;
    metadata: MetadataEntityData;
    forms: EntityFormDefinition[];
}


